export const VC = 'vc'
export const LOS = 'los'
export const ROADWAY_FEATURE_VALUES = [
  'Wider edge lines',
  'Longitudinal rumble strips and stripes',
  'SafetyEdge',
  'Backplates with reflective borders'
]
